import {
  setThemeMode,
  toggleThemeMode,
  hydrateThemeFromStorage,
} from "../slices/theme";
import { updateUserPreferences } from "../../api/users";

/**
 * Middleware to sync theme changes to the backend
 * Updates user preferences in the database when theme mode changes
 */
export const themeSyncMiddleware = (store) => (next) => (action) => {
  // Call the next middleware/reducer first
  const result = next(action);

  // Check if this is a theme mode change action
  if (
    hydrateThemeFromStorage.match(action) ||
    !(setThemeMode.match(action) || toggleThemeMode.match(action))
  ) {
    return result;
  }

  const state = store.getState();
  const themeMode = state.theme.mode;
  const userPreferences = state.user?.user?.user_preferences;
  const isAuthenticated = state.user?.isAuthenticated;
  const isLoadingFromBackend = userPreferences?.theme === themeMode;

  if (isAuthenticated && !isLoadingFromBackend) {
    updateUserPreferences({ theme: themeMode })
      .then((response) => {
        if (response.error) {
          console.warn("Failed to update theme preference in backend:", response.error);
        }
      })
      .catch((error) => {
        console.warn("Error updating theme preference in backend:", error);
      });
  }

  return result;
};
